import { Box, Button, Chip, Typography } from "@mui/material";

import { Paper } from "@mui/material";

import { Stack } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import api from "../api";
import { enqueueSnackbar, useSnackbar } from "notistack";
import { useEffect, useState } from "react";
import CustomDataGrid from "../components/CustomDataGrid";
import { getBackendUrl } from "../util/envFn";
import { formatDate } from "../util/date";

type Application = {
    _id: string;
    jobId: string;
    userId: string;
    accepted: boolean;
    appliedAt: string;
    jobTitle: string;
    userEmail: string;
}

const SelfCreateApplications = () => {
    const [applications, setApplications] = useState<Application[]>([]);
    const { enqueueSnackbar } = useSnackbar();

    const fetchApplications = () => {
        api.get(getBackendUrl('/applications/self-create'))
            .then(res => {
                setApplications(res.data.map((application: Application) => ({
                    ...application,
                    id: application._id,
                })));
            })
            .catch(error => {
                enqueueSnackbar('Error fetching applications', { variant: 'error' });
            });
    }

    useEffect(() => {
        fetchApplications();
    }, []);

    const handleAccept = (id: string) => {
        api.post(getBackendUrl(`/applications/accept/${id}`))
            .then(res => {
                fetchApplications();
                enqueueSnackbar('Application accepted successfully', { variant: 'success' });
            })
            .catch(error => {
                enqueueSnackbar('Error accepting application', { variant: 'error' });
            });
    }

    const columns: GridColDef[] = [
        { field: 'jobTitle', headerName: 'Job', width: 200 },
        { field: 'userEmail', headerName: 'User', width: 200 },
        {
            field: 'appliedAt', headerName: 'Applied At', width: 200,
            renderCell: (params) => <Box>{formatDate(params.row.appliedAt)}</Box>
        },
        {
            field: 'accepted', headerName: 'Status', width: 200,
            renderCell: (params) => params.row.accepted ? <Chip label="Accepted" color="success" /> : <Chip label="Pending" color="warning" />
        },
        {
            field: 'actions', headerName: 'Actions', width: 200, renderCell: (params) => {
                if (params.row.accepted) {
                    return (
                        <Stack className="MuiDataGrid-cell " height={1} justifyContent="center" >
                            <Typography >-</Typography>
                        </Stack>
                    )
                }

                return <Button variant="contained" color="success" onClick={() => handleAccept(params.row.id)}>Accept</Button>
            }
        },
    ];

    return (
        <Stack maxWidth="100dvw" overflow="auto">
            <Stack padding={2} gap={3}>
                <Typography variant="h4" component="h2">
                    People who applied for your jobs
                </Typography>
                <Paper elevation={3} sx={{ height: 400, maxWidth: '100%' }}>
                    <CustomDataGrid
                        rows={applications}
                        columns={columns}
                        initialState={{
                            pagination: {
                                paginationModel: { page: 0, pageSize: 5 },
                            },
                        }}
                    />
                </Paper>
            </Stack>
        </Stack>
    )
}

export default SelfCreateApplications;
